import { AccomodationEnum } from '../../types/enums/accomodation-type/accomodation-type'
import { StaffPaymentStatusEnum } from '../../types/enums/affected-staff/staff-payment-status.enum'
import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { TravelExpensesSalaryStaffsFilters } from '../../types/models/travel-expenses/travel-expenses-staff'

export const transformTravelExpensesStaffSalaryFiltersToUrl = (
  filters?: TravelExpensesSalaryStaffsFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))

  if (filters.formulas && filters.formulas.length)
    searchParams.append('formulas', filters.formulas.join(','))

  if (filters.qualifications && filters.qualifications.length)
    searchParams.append('qualifications', filters.qualifications.join(','))

  if (filters.positions && filters.positions.length)
    searchParams.append('positions', filters.positions.join(','))

  if (filters.paymentStatuses && filters.paymentStatuses.length)
    searchParams.append('paymentStatuses', filters.paymentStatuses.join(','))

  if (filters.departureDateFrom)
    searchParams.append('departureDateFrom', filters.departureDateFrom)

  if (filters.departureDateTo) searchParams.append('departureDateTo', filters.departureDateTo)

  if (filters.arrivalDateFrom) searchParams.append('arrivalDateFrom', filters.arrivalDateFrom)

  if (filters.arrivalDateTo) searchParams.append('arrivalDateTo', filters.arrivalDateTo)

  if (filters.accomodations && filters.accomodations.length)
    searchParams.append('accomodations', filters.accomodations.join(','))

  if (filters.trips && filters.trips.length) searchParams.append('trips', filters.trips.join(','))

  if (filters.travelExpensesSentAtFrom)
    searchParams.append('travelExpensesSentAtFrom', filters.travelExpensesSentAtFrom)

  if (filters.travelExpensesSentAtTo)
    searchParams.append('travelExpensesSentAtTo', filters.travelExpensesSentAtTo)

  return searchParams.toString()
}

export const transformUrlToTravelExpensesStaffSalaryFilters = (
  searchParams: URLSearchParams
): TravelExpensesSalaryStaffsFilters => {
  const filters: TravelExpensesSalaryStaffsFilters = {}

  const countries = searchParams.get('countries')
  if (countries && countries.length) filters.countries = countries.split(',').map((code) => code)

  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',').map((id) => parseInt(id))

  const formulas = searchParams.get('formulas')
  if (formulas && formulas.length) filters.formulas = formulas.split(',').map((id) => parseInt(id))

  const qualifications = searchParams.get('qualifications')
  if (qualifications && qualifications.length)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  const positions = searchParams.get('positions')
  if (positions && positions.length)
    filters.positions = positions.split(',') as StaffPositionEnum[]

  const paymentStatuses = searchParams.get('paymentStatuses')
  if (paymentStatuses && paymentStatuses.length)
    filters.paymentStatuses = paymentStatuses.split(',') as StaffPaymentStatusEnum[]

  const departureDateFrom = searchParams.get('departureDateFrom')
  if (departureDateFrom && departureDateFrom.length) filters.departureDateFrom = departureDateFrom

  const departureDateTo = searchParams.get('departureDateTo')
  if (departureDateTo && departureDateTo.length) filters.departureDateTo = departureDateTo

  const arrivalDateFrom = searchParams.get('arrivalDateFrom')
  if (arrivalDateFrom && arrivalDateFrom.length) filters.arrivalDateFrom = arrivalDateFrom

  const arrivalDateTo = searchParams.get('arrivalDateTo')
  if (arrivalDateTo && arrivalDateTo.length) filters.arrivalDateTo = arrivalDateTo

  const accomodations = searchParams.get('accomodations')
  if (accomodations && accomodations.length)
    filters.accomodations = accomodations.split(',') as AccomodationEnum[]

  const trips = searchParams.get('trips')
  if (trips && trips.length) filters.trips = trips.split(',').map((id) => parseInt(id))

  const travelExpensesSentAtFrom = searchParams.get('travelExpensesSentAtFrom')
  if (travelExpensesSentAtFrom && travelExpensesSentAtFrom.length)
    filters.travelExpensesSentAtFrom = travelExpensesSentAtFrom

  const travelExpensesSentAtTo = searchParams.get('travelExpensesSentAtTo')
  if (travelExpensesSentAtTo && travelExpensesSentAtTo.length)
    filters.travelExpensesSentAtTo = travelExpensesSentAtTo

  return filters
}
